import React from 'react'
import { Field } from 'redux-form'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'
import { TAB_INDEXES } from 'shared/helpers/AccessibilityHelper'

const SendMessage = ({ errors, ctaClass, getTranslation }) => (
  <div className={`send-message-form-fields ${ctaClass}`}>
    <div className="input-field-container">
      <label className="field-label">{getTranslation(TRANSLATION_VALUE_KEYS.yourEmail)}</label>
      <Field
        className={`${errors.email ? 'error' : ''}`}
        name="email"
        component="input"
        type="email"
        autoFocus={true}
        tabIndex={TAB_INDEXES.SendMessageField}
        placeholder={`* ${getTranslation(TRANSLATION_VALUE_KEYS.yourEmailHere)}`} />
    </div>
    <div className="input-field-container">
      <label className="field-label">{getTranslation(TRANSLATION_VALUE_KEYS.yourMessage)}</label>
      <Field
        className={`${errors.message ? 'error' : ''}`}
        name="message"
        component="textarea"
        tabIndex={TAB_INDEXES.SendMessageField}
        placeholder={`${getTranslation(TRANSLATION_VALUE_KEYS.yourMessageHere)}...`} />
    </div>
  </div>
)

SendMessage.propTypes = {
  errors: PropTypes.object,
  ctaClass: PropTypes.string
}

export default withTranslation(TRANSLATION_KEYS.ctaSendMessage)(SendMessage)
